import { useState } from 'react';

import { Button } from '@/components/core/Button';
import { Checkbox } from '@/components/core/Checkbox';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
} from '@/components/core/Dialog';
import { LOCAL_STORAGE } from '@/constants';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useTranslation } from '@/hooks/useTranslation';
import { useUser } from '@/hooks/useUser';

const GroupDeleteConfirmationDialog = ({
    open,
    onClose,
    onRemove,
}: {
    open: boolean;
    onClose: () => void;
    onRemove: () => void;
}) => {
    const { t } = useTranslation();
    const [disableDialog, setDisableDialog] = useState(false);
    const { user } = useUser();
    const [isDeleteConfirmationDisabled, setIsDeleteConfirmationDisabled] =
        useLocalStorage<boolean>(
            `${LOCAL_STORAGE.DISABLE_DELETE_CONFIRMATION}${user?.id}`,
            false,
        );

    const onDeleteGroup = (disableDialog: boolean) => {
        setIsDeleteConfirmationDisabled(disableDialog);
        onRemove();
        onClose();
    };

    if (isDeleteConfirmationDisabled) {
        onRemove();
        return null;
    }

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent
                variant="small"
                onPointerDownOutside={() => onClose()}
                onInteractOutside={() => onClose()}
            >
                <DialogHeader>{t('CONFIRM_DELETE')}</DialogHeader>

                <div className="tw-p-4">
                    <div>{t('EDITOR.DELETE_CONFIRMATION_TEXT.GROUP')}</div>

                    <div className="tw-pt-2">
                        <Checkbox
                            isChecked={disableDialog}
                            onCheckedChange={(isChecked: boolean) =>
                                setDisableDialog(isChecked)
                            }
                            className="tw-mr-2"
                        />
                        {t('EDITOR.DISABLE_DELETE_CONFIRMATION')}
                    </div>
                </div>
                <DialogFooter>
                    <Button
                        id="use-datamodel"
                        type="submit"
                        variant="destructive"
                        onClick={() => onDeleteGroup(disableDialog)}
                    >
                        {t('ACTION.DELETE')}
                    </Button>
                    <DialogClose asChild={true}>
                        <Button variant="secondary" onClick={() => onClose()}>
                            {t('NO')}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default GroupDeleteConfirmationDialog;
